module.exports = __webpack_public_path__ + "RAND-logo-2d18be456ed32821c6f6516858f05498.png";